import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";
import i18n, { I18N_NS } from "Config/i18n";

type SubMenus = "DOCUMENTS" | "VIEW";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config: SubmenuItem[] = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "DOCUMENTS_AND_PLANS")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;

    if (subModules) {
      subModules.includes("DOCUMENTS") &&
        config.push({
          label: <MenuItemWithBadge label={`Folder view`} />,
          icon: "folder-tree",
          link: "docs",
          message: i18n.t("Folders and sub-folders structure to organise files", { ns: I18N_NS.PROJECT }),
        });
      subModules.includes("VIEW") &&
        config.push({
          label: <MenuItemWithBadge label={`Table view`} />,
          icon: "table",
          link: "views",
          message: i18n.t("Table view on files based on their meta data", { ns: I18N_NS.PROJECT }),
        });
    }

    return config;
  },
};
